<template>
  <div class="login-bg">
    <div class="login-cont container" style="height: auto; min-height: 80vh;">
      <div class="d-flex justify-content-center h-100">
        <div class="col-12 px-0 d-flex flex-column my-auto">
          <div class="card-body px-2 d-flex mx-0 col-12 mx-auto auth-card-glass">
            <div class="col-12 py-2">
              <div class="text-center mb-4">
                <div class="error text-center py-2" v-if="error">
                  <span class="mx-auto">{{ $t('auth.fail_message') }}</span>
                </div>
              </div>
              <form role="form">
                <small class="text-dark">{{ errors.name }}</small>
                <div class="form-group mb-3">
                  <label class="auth-label">{{ $t('auth.username') }}</label>
                  <input
                    class="form-control pl-2 px-4 auth-input"
                    type="text"
                    v-model="name"
                    @keyup.enter="focusOnPhoneInputBox"
                  />
                </div>

                <small class="text-dark">{{ errors.phone }}</small>
                <div class="form-group mb-3 pt-1">
                  <label class="auth-label">{{ $t('setting.phone') }}</label>
                  <input
                    class="form-control pl-2 px-4 auth-input"
                    type="text"
                    ref="phone"
                    v-model="phone"
                    @keyup.enter="focusOnPasswordInputBox"
                  />
                </div>

                <small class="text-dark">{{ errors.password }}</small>
                <div class="form-group pt-1">
                  <label class="auth-label">{{ $t('auth.password') }}</label>
                  <div class="input-group">
                    <input
                      class="form-control pl-2 px-4 auth-input"
                      type="password"
                      ref="password"
                      v-model="password"
                      @keyup.enter="focusOnConfirmPasswordInputBox"
                    />
                    <i
                      class="far fa-eye showable-password text-dark"
                      v-if="isShowPassword"
                      @click="showablePassword('password')"
                    ></i>
                    <i
                      v-if="!isShowPassword"
                      class="fas fa-eye-slash showable-password text-dark"
                      @click="showablePassword('password')"
                    ></i>
                  </div>
                </div>

                <small class="text-dark">{{ errors.confirm_password }}</small>
                <div class="form-group pt-3">
                  <label class="auth-label">{{ $t('auth.confirm_password') }}</label>
                  <div class="input-group">
                    <input
                      class="form-control pl-2 px-4 auth-input"
                      type="password"
                      ref="confirm_password"
                      v-model="confirm_password"
                      @keyup.enter="registerAccount"
                    />
                    <i
                      class="far fa-eye showable-password text-dark"
                      v-if="isShowConfirmPassword"
                      @click="showablePassword('confirm_password')"
                    ></i>
                    <i
                      v-if="!isShowConfirmPassword"
                      class="fas fa-eye-slash showable-password text-dark"
                      @click="showablePassword('confirm_password')"
                    ></i>
                  </div>
                </div>

                <div class="auth-actions">
                  <button
                    type="button"
                    class="auth-btn auth-btn--solid"
                    @click="registerAccount()"
                  >
                    <template v-if="!isSignin">
                      <i class="fas fa-user-plus auth-btn__icon" aria-hidden="true"></i>
                      {{ $t('auth.sign_up') }}
                    </template>
                    <Loading v-else color="#ffffff" size="24" class="px-4 py-0" />
                  </button>

                  <button
                    type="button"
                    class="auth-btn auth-btn--outline"
                    @click="$router.push('/auth/login')"
                  >
                    <i class="fas fa-sign-in-alt auth-btn__icon" aria-hidden="true"></i>
                    {{ $t('auth.login') }}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast, Loading } from 'vant';
import { mapActions } from 'vuex';

export default {
  components: { Loading },
  data() {
    return {
      name: null,
      phone: null,
      password: null,
      confirm_password: null,
      error: false,
      errors: {},
      isSignin: false,
      isShowPassword: false,
      isShowConfirmPassword: false,
    };
  },
  methods: {
    ...mapActions(['fetchUser']),
    showablePassword(ref) {
      if (ref === 'password') {
        this.$refs[ref].type = this.isShowPassword ? 'password' : 'text';
        this.isShowPassword = !this.isShowPassword;
      } else {
        this.$refs[ref].type = this.isShowConfirmPassword ? 'password' : 'text';
        this.isShowConfirmPassword = !this.isShowConfirmPassword;
      }
    },
    focusOnPhoneInputBox() {
      this.$refs.phone.focus();
    },
    focusOnPasswordInputBox() {
      this.$refs.password.focus();
    },
    focusOnConfirmPasswordInputBox() {
      this.$refs.confirm_password.focus();
    },
    async registerAccount() {
      this.isSignin = true;
      this.errors = {};
      this.error = false;

      if (!this.name) {
        this.errors.name = this.$t('auth.require_username');
        this.isSignin = false;
        return false;
      }
      if (!this.phone) {
        this.errors.phone = this.$t('auth.require_phone');
        this.isSignin = false;
        return false;
      }
      if (!this.password) {
        this.errors.password = this.$t('auth.require_password');
        this.isSignin = false;
        return false;
      }
      if (!this.confirm_password) {
        this.errors.confirm_password =
          this.$store.state.language === 'en'
            ? 'Confirm Password is required'
            : 'Confirm Password လိုအပ်ပါသည်။';
        this.isSignin = false;
        return false;
      }
      if (this.confirm_password !== this.password) {
        this.errors.confirm_password =
          this.$store.state.language === 'en'
            ? 'Password not match!'
            : 'Password not match!';
        this.isSignin = false;
        return false;
      }

      try {
        const res = await this.axios.post('/auth/register', {
          user_name: this.name,
          phone: this.phone,
          password: this.password,
          confirmPassword: this.confirm_password,
          roles: 'normal',
          referralCode: localStorage.getItem('referralCode'),
        });
        localStorage.setItem('username', this.phone);
        localStorage.setItem('password', this.password);
        localStorage.setItem('token', res.data.token);
        const currentTime = new Date();
        localStorage.setItem(
          'tokenExpire',
          new Date(currentTime.getTime() + 60 * 60 * 1000),
        );
        this.axios.defaults.headers.common.Authorization = `Bearer ${res.data.token}`;
        await this.fetchUser();
        this.$router.push('/home');
        Toast.success(this.$store.state.language === 'en' ? 'Success!' : 'Success!');
      } catch (err) {
        this.error = true;
      }
      this.isSignin = false;
      return true;
    },
  },
  async mounted() {
    if (this.$route.query.code) {
      localStorage.setItem('referralCode', this.$route.query.code);
    }
    const authUser = await this.fetchUser();
    if (authUser && this.$store.state.authUser.roles === 'normal') {
      this.$router.push('/home');
    }
  },
};
</script>

<style scoped lang="scss">
@import '@/scss/auth-page.scss';
</style>
